import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import MainLayout from '../Layout/MainLayout';
import styles from '../../assets/styles/Setting.module.scss';

const AccountSettingsLayout: React.FC<{ children: React.ReactNode }> = ({ children }) => {

  const location = useLocation();
  const navigate = useNavigate();

  const tabs = [
    { label: 'アカウント設定', path: '/account-setting/profile' },
    { label: '企業情報', path: '/account-setting/corporate' },
    { label: 'プラン・決済', path: '/account-setting/plan' },
  ];

  const isActive = (path: string) => location.pathname === path;

  const headerContent = (
    <nav className={styles.settingsNav}>
      {tabs.map((tab) => (
        <button
          key={tab.path}
          onClick={() => navigate(tab.path)}
          className={`${styles.tabButton} ${isActive(tab.path) ? styles.active : ''}`}
        >
          {tab.label}
        </button>
      ))}
    </nav>
  );

  return (
    <MainLayout title="アカウント設定" headerContent={headerContent}>
      <div className={styles.settingDetail}>
        {children}
      </div>
    </MainLayout>
  );
};

export default AccountSettingsLayout;
